import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function DropdownAnchorItem({
  href,
  to,
  state,
  children,
  className,
  style,
  onRequestClose,
}) {
  const navigate = useNavigate();
  const url = href ?? to;

  const stop = (e) => e.stopPropagation();

  const handleClick = (e) => {
    if (!url) return;

    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      e.altKey
    ) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    onRequestClose?.();
    navigate(url, { state });
  };

  if (!url) return null;

  return (
    <a
      href={url}
      className={className}
      style={{
        textDecoration: 'none',
        color: 'inherit',
        display: 'block',
        margin: '-1rem',
        ...style,
      }}
      onMouseDownCapture={stop}
      onPointerDownCapture={stop}
      onContextMenuCapture={stop}
      onClick={handleClick}
    >
      <p className='p-3'>{children}</p>
    </a>
  );
}
